export default __webpack_public_path__ + "static/media/ic_check_active.a3cc7b74.svg";